import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { Button } from "@repo/ui/components/Base/Button";
import { useState } from "react";

export interface ArchiveConfirmationProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
  itemId: string;
  onSubmit?: (itemId: string) => void | Promise<void>;
  onDeleted?: () => void | Promise<void>;
  message?: React.ReactNode;
}

export const ArchiveConfirmation = ({
  open,
  setOpen,
  itemId,
  onSubmit,
  onDeleted,
  message = "Archiving this will remove it from all linked items.",
}: ArchiveConfirmationProps) => {
  const [loading, setLoading] = useState(false);

  const handleOpenChange = () => setOpen(!open);

  const handleConfirm = async () => {
    setLoading(true);
    await onSubmit?.(itemId);
    await onDeleted?.();
    setOpen(false);
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
        </DialogHeader>
        <DialogDescription>{message}</DialogDescription>
        <DialogFooter className="sm:justify-between">
          <Button
            onClick={handleOpenChange}
            variant="destructive"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button onClick={() => handleConfirm()} disabled={loading}>
            Confirm Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
